
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autori/[slug]",
      function () {
        return require("private-next-pages/autori/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autori/[slug]"])
      });
    }
  